var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.contentWidth === 'boxed' ? 'container p-0' : null},[_c('router-view'),(_vm.isFooter)?_c('div',{staticClass:"pb-5"}):_vm._e(),(_vm.isFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }